module.exports = __webpack_public_path__ + "assets/img/Exchange_btn.3fe1bacc.png";